import React, { useState } from 'react';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../mock';
import PrivacyPolicyModal from './PrivacyPolicyModal';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { label: 'Početna', id: 'hero' },
    { label: 'O nama', id: 'about' },
    { label: 'Usluge', id: 'services' },
    { label: 'Galerija', id: 'gallery' },
    { label: 'Kontakt', id: 'contact' }
  ];

  const services = [
    'Ugostiteljstvo',
    'Catering oprema',
    'Organizacija događaja',
    'Koncerti',
    'Smještaj',
    'Logistika',
    'Nekretnine',
    'Građevinski materijal'
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-amber-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">TD</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">TDM DRAGON</h3>
                <p className="text-xs text-gray-400">promet d.o.o.</p>
              </div>
            </div>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Vaš pouzdan partner za profesionalne usluge u različitim poslovnim sektorima.
            </p>
            <div className="flex space-x-3">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 hover:bg-amber-600 rounded-lg flex items-center justify-center transition-colors duration-200"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 hover:bg-amber-600 rounded-lg flex items-center justify-center transition-colors duration-200"
              >
                <Instagram size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 hover:bg-amber-600 rounded-lg flex items-center justify-center transition-colors duration-200"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Brzi linkovi</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-amber-400 transition-colors duration-200"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Naše usluge</h4>
            <ul className="space-y-2">
              {services.slice(0, 5).map((service, index) => (
                <li key={index}>
                  <span className="text-gray-400 hover:text-amber-400 transition-colors duration-200 cursor-pointer">
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Kontakt informacije</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="text-amber-500 flex-shrink-0 mt-1" size={18} />
                <span className="text-gray-400 text-sm">{companyInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="text-amber-500 flex-shrink-0" size={18} />
                <a href={`tel:${companyInfo.phone}`} className="text-gray-400 hover:text-amber-400 text-sm">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="text-amber-500 flex-shrink-0" size={18} />
                <a href={`mailto:${companyInfo.email}`} className="text-gray-400 hover:text-amber-400 text-sm">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} TDM DRAGON promet d.o.o. Sva prava pridržana.
            </p>
            <div className="text-sm">
              <button 
                onClick={() => setIsPrivacyModalOpen(true)}
                className="text-gray-400 hover:text-amber-400 transition-colors"
              >
                Politika privatnosti
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <PrivacyPolicyModal 
        isOpen={isPrivacyModalOpen} 
        onClose={() => setIsPrivacyModalOpen(false)} 
      />
    </footer>
  );
};

export default Footer;